<!-- ── Faixa fechada ───────────────────────────────────────── -->
<div *ngIf="mostraFaixa" class="oferta-card faixa">
  <div class="flex items-center gap-3 flex-wrap">
    <span class="eyebrow">{{ nomePlano }} · melhorar plano</span>
    <span *ngIf="eleg?.atual" class="selo" [style.background-color]="corAtual.fundo" [style.color]="corAtual.texto">Hoje: {{ familiaAtual }}</span>
  </div>
  <button type="button" class="btn btn-sucesso" (click)="abrir()">Ver opções de upgrade</button>
</div>

<!-- ── Carregando ──────────────────────────────────────────── -->
<div *ngIf="verificando" class="oferta-carregando">
  <span class="eyebrow">{{ nomePlano }} · melhorar plano</span>
  <div class="flex gap-5 items-center flex-wrap">
    <div class="cartao-esqueleto"><span class="cartao-marca">{{ nomePlano }}</span></div>
    <div class="flex-1 flex flex-col gap-2" style="min-width: 220px">
      <p class="frase-carregando" aria-live="polite">{{ frasesCarregando[fraseAtual] }}</p>
      <span class="barra-esqueleto" style="width: 70%"></span>
      <span class="barra-esqueleto" style="width: 45%"></span>
    </div>
  </div>
</div>

<div *ngIf="mostra" class="oferta-card">
  <div class="flex items-center justify-between gap-3 flex-wrap">
    <div class="flex items-center gap-3 flex-wrap">
      <span class="eyebrow">{{ nomePlano }} · melhorar plano</span>
      <span *ngIf="eleg?.atual" class="selo" [style.background-color]="corAtual.fundo" [style.color]="corAtual.texto">Hoje: {{ familiaAtual }}</span>
    </div>
    <div *ngIf="eleg?.pode && etapa === 'plano' && grupos.length" class="trilho" role="tablist">
      <button *ngFor="let g of grupos; let i = index" type="button" class="aba"
              [class.aba-ativa]="i === grupoIdx" [attr.aria-pressed]="i === grupoIdx" (click)="escolherGrupo(i)">
        <span class="ponto" [style.background-color]="corDaFamilia(g.familia).fundo"></span>{{ nomeCurto(g.nome) }}
      </button>
    </div>
  </div>

  <!-- Recusa -->
  <ng-container *ngIf="textoBloqueio">
    <div class="flex gap-5 flex-wrap items-center">
      <div *ngIf="eleg?.atual" class="cartao-plano" [style.background-color]="corAtual.fundo" [style.color]="corAtual.texto"
           [style.box-shadow]="'0 14px 28px -16px ' + corAtual.sombra">
        <span class="cartao-marca">{{ nomePlano }}</span>
        <span class="cartao-nome">{{ familiaAtual }}</span>
      </div>
      <div class="flex-1" style="min-width: 230px">
        <p class="hero-titulo">{{ textoBloqueio }}</p>
      </div>
    </div>
    <div *ngIf="permiteNovaTentativa" class="rodape" style="justify-content: flex-end">
      <button type="button" class="btn btn-accent" [disabled]="carregando" (click)="carregar()">Tentar de novo</button>
    </div>
  </ng-container>

  <ng-container *ngIf="eleg?.pode">
    <!-- 1. Plano -->
    <ng-container *ngIf="etapa === 'plano'">
      <p *ngIf="eleg?.pendente as p" class="aviso">
        Existe uma migração aguardando pagamento ({{ p.nomePlano }}). Escolha o mesmo plano e a mesma forma para continuar nela.
      </p>

      <ng-container *ngIf="grupo as g">
        <div class="flex gap-5 flex-wrap items-center">
          <div class="cartao-plano" [style.background-color]="corDestino.fundo" [style.color]="corDestino.texto"
               [style.box-shadow]="'0 14px 28px -16px ' + corDestino.sombra">
            <span class="cartao-marca">{{ nomePlano }}</span>
            <span class="cartao-nome">{{ nomeCurto(g.nome) }}</span>
          </div>
          <div class="flex-1" style="min-width: 230px">
            <p class="hero-titulo">De {{ familiaAtual }} para {{ nomeCurto(g.nome) }}</p>
            <p class="hero-sub">
              Plano <b class="valor">{{ destino?.opcao?.valor | brl }}{{ ciclo === 'anual' ? '/ano' : '/mês' }}</b>
            </p>
          </div>
        </div>

        <div *ngIf="g.beneficios.length" class="flex flex-col gap-2">
          <span class="rotulo">Benefícios do {{ nomeCurto(g.nome) }}</span>
          <ul class="beneficios">
            <li *ngFor="let b of g.beneficios">
              <span class="check" [style.background-color]="corDestino.fundo" [style.color]="corDestino.texto">✓</span>{{ b }}
            </li>
          </ul>
        </div>

        <div class="rodape">
          <div class="trilho">
            <button *ngIf="g.mensal as m" type="button" class="segmento" [class.segmento-ativo]="ciclo === 'mensal'"
                    [attr.aria-pressed]="ciclo === 'mensal'" (click)="escolherCiclo('mensal')">
              Mensal <span class="valor">{{ m.opcao.valor | brl }}</span>
            </button>
            <button *ngIf="g.anual as a" type="button" class="segmento" [class.segmento-ativo]="ciclo === 'anual'"
                    [attr.aria-pressed]="ciclo === 'anual'" (click)="escolherCiclo('anual')">
              Anual <span class="valor">{{ a.opcao.valor | brl }}</span>
            </button>
          </div>

          <div *ngIf="destino?.intervalo === 1 && destino?.opcao?.aceitaVencimento" class="vencimento">
            <span class="rotulo">Vencimento</span>
            <div class="trilho">
              <button *ngFor="let d of DIAS_VENCIMENTO" type="button" class="segmento" [class.segmento-ativo]="diaVencimento === d"
                      [attr.aria-pressed]="diaVencimento === d" (click)="diaVencimento = d">dia {{ d }}</button>
            </div>
            <p class="resumo vencimento-info">Próximas mensalidades vencem todo dia {{ diaVencimento }}</p>
          </div>

          <button type="button" class="btn btn-accent" [disabled]="!destino" (click)="irParaDependentes()">Continuar</button>
        </div>
      </ng-container>
    </ng-container>

    <!-- 2. Dependentes -->
    <ng-container *ngIf="etapa === 'dependentes'">
      <p class="hero-titulo">Dependentes no {{ nomeCurto(destino?.nome ?? '') }}</p>
      <div class="canais">
        <button *ngFor="let d of eleg!.dependentes" type="button" class="canal"
                [class.canal-ativo]="mantidos.has(d.pessoaId)" [attr.aria-pressed]="mantidos.has(d.pessoaId)"
                (click)="alternar(d.pessoaId)">
          <span class="canal-radio"></span>
          <span class="flex flex-col min-w-0 text-left flex-1">
            <span class="canal-nome">{{ d.nome || d.pessoaId }}</span>
            <span class="canal-destino">{{ formatarCpf(d.cpf) }}</span>
          </span>
          <span class="dep-estado" [class.dep-retira]="!mantidos.has(d.pessoaId)">{{ mantidos.has(d.pessoaId) ? 'Mantém' : 'Retira' }}</span>
        </button>
      </div>
      <div class="rodape">
        <button type="button" class="btn-ghost" (click)="etapa = 'plano'">Voltar</button>
        <p class="resumo">Estimativa: <b class="valor">{{ precoEstimado | brl }}</b> por mês com {{ mantidos.size }} dependente(s).</p>
        <button type="button" class="btn btn-accent" [disabled]="!!problemaDependentes" (click)="avancarDependentes()">Continuar</button>
      </div>
      <p *ngIf="problemaDependentes" class="erro" role="alert">{{ problemaDependentes }}</p>
    </ng-container>

    <!-- 3. Termo -->
    <ng-container *ngIf="etapa === 'termo'">
      <div class="termo">
        <div class="flex items-center justify-between gap-2 flex-wrap">
          <span class="rotulo">Termo de adesão do {{ nomeCurto(destino?.nome ?? '') }}</span>
          <span *ngIf="!termoLiberado" class="text-xs" style="color: var(--brand-muted)">A cobrança libera quando o paciente assinar</span>
        </div>

        <div *ngIf="!termoLiberado" class="canais" role="radiogroup" aria-label="Canal do termo">
          <div *ngFor="let c of canais" class="canal" role="radio"
               [class.canal-ativo]="canal === c.id" [attr.aria-checked]="canal === c.id"
               [class.canal-inativo]="!destinoDoCanal(c.id) && editandoCanal !== c.id"
               (click)="destinoDoCanal(c.id) && editandoCanal !== c.id && !isEnviando ? canal = c.id : null">
            <span class="canal-radio"></span>
            <span class="flex flex-col min-w-0 text-left flex-1">
              <span class="canal-nome">
                {{ c.nome }}
                <span *ngIf="contatoFoiEditado(c.id)" class="canal-editado">corrigido</span>
              </span>
              <ng-container *ngIf="editandoCanal !== c.id">
                <span class="canal-destino">{{ destinoDoCanal(c.id) ? formatarDestino(c.id, destinoDoCanal(c.id)) : c.semContato }}</span>
              </ng-container>
              <div *ngIf="editandoCanal === c.id" class="canal-edicao" (click)="$event.stopPropagation()">
                <input [(ngModel)]="valorEdicao" [attr.inputmode]="c.id === 'sms' ? 'numeric' : 'email'"
                       [placeholder]="c.id === 'sms' ? '(85) 99999-9999' : 'email@paciente.com'"
                       (keydown.enter)="salvarContato()" (keydown.escape)="cancelarEdicao()" />
                <button type="button" class="link" (click)="salvarContato()">Salvar</button>
                <button type="button" class="link link-neutro" (click)="cancelarEdicao()">Cancelar</button>
              </div>
              <span *ngIf="editandoCanal === c.id && erroEdicao" class="canal-erro">{{ erroEdicao }}</span>
            </span>
            <button *ngIf="editandoCanal !== c.id" type="button" class="link canal-editar"
                    [disabled]="isEnviando" (click)="$event.stopPropagation(); editarContato(c.id)">
              {{ destinoDoCanal(c.id) ? 'Editar' : 'Informar' }}
            </button>
          </div>
        </div>

        <p class="termo-status" aria-live="polite">
          <ng-container *ngIf="termoLiberado">
            <span class="status-ok">✓</span>
            <ng-container *ngIf="termoImportado as importado; else assinado">
              Termo assinado importado (PDF) em {{ importado.enviadoEm | date: 'dd/MM HH:mm' }}
            </ng-container>
            <ng-template #assinado>Termo assinado em {{ termo!.assinadoEm | date: 'dd/MM HH:mm' }}</ng-template>
          </ng-container>
          <ng-container *ngIf="!termoLiberado && termoEnviadoPara as enviado">
            <span class="status-ok">✓</span>
            Enviado por {{ enviado.canal === 'sms' ? 'SMS' : 'e-mail' }} para {{ formatarDestino(enviado.canal, enviado.destino) }}
            às {{ enviado.em | date: 'HH:mm' }}. Aguardando o paciente assinar ·
            <button type="button" class="link" [disabled]="verificandoTermo" (click)="verificarTermo()">
              {{ verificandoTermo ? 'Verificando...' : 'Verificar assinatura' }}
            </button> ·
            <button type="button" class="link" [disabled]="isEnviando || !destinoDoCanal(canal)" (click)="enviarTermo()">
              {{ isEnviando ? 'Reenviando...' : 'Reenviar' + (canal !== enviado.canal ? ' por ' + (canal === 'sms' ? 'SMS' : 'e-mail') : '') }}
            </button>
          </ng-container>
          <ng-container *ngIf="!termoLiberado && !termoEnviadoPara">
            Envie o termo e peça para o paciente assinar no celular; a cobrança libera quando a assinatura chegar.
          </ng-container>
        </p>

        <div *ngIf="!termoLiberado" class="termo-importar">
          <input #arquivoTermo type="file" accept="application/pdf" hidden (change)="importarTermo($event)" />
          <button *ngIf="destino" type="button" class="link" (click)="baixarTermoModelo()" [disabled]="baixandoModelo">
            {{ baixandoModelo ? 'Baixando…' : 'Baixar termo para preencher' }}
          </button>
          <span>Assinou no papel?</span>
          <button type="button" class="link" [disabled]="isImportando" (click)="arquivoTermo.click()">
            {{ isImportando ? 'Importando termo...' : 'Importar termo assinado (PDF)' }}
          </button>
        </div>
      </div>

      <div class="rodape">
        <button type="button" class="btn-ghost" (click)="irParaDependentes()">Voltar</button>
        <button *ngIf="!termoLiberado && termoEnviadoPara" type="button" class="btn btn-accent" disabled
                title="A cobrança libera quando o paciente assinar o termo">
          Aguardando assinatura...
        </button>
        <button *ngIf="!termoLiberado && !termoEnviadoPara" type="button" class="btn btn-accent"
                [disabled]="isEnviando || !destinoDoCanal(canal)" (click)="enviarTermo()">
          {{ isEnviando ? 'Enviando termo...' : 'Enviar termo por ' + (canal === 'sms' ? 'SMS' : 'e-mail') }}
        </button>
        <button *ngIf="termoLiberado" type="button" class="btn btn-sucesso" (click)="irParaCobranca()">Ir para a cobrança</button>
      </div>
    </ng-container>

    <!-- 4. Cobrança -->
    <ng-container *ngIf="etapa === 'cobranca'">
      <p class="resumo">
        Cobrança hoje: <b class="valor">{{ valorCobranca | brl }}</b>. O plano atual é cancelado quando o pagamento for confirmado.
      </p>
      <p *ngIf="valorDiferente" class="aviso">
        O CartãoSiM calculou <span class="valor">{{ pagamento?.valor | brl }}</span>; a estimativa era <span class="valor">{{ precoEstimado | brl }}</span>.
      </p>
      <p *ngIf="removeuDependente" class="aviso">
        O valor final pode ser maior que a estimativa: o CartãoSiM também cobra dependentes retirados.
      </p>
      <app-cobranca-sim [acoes]="acoes" [valor]="valorCobranca" [guiche]="guiche" [aceitaPix]="aceitaPix"
                        [podeEnviarLink]="!!cliente?.id" [cobrancaCriada]="temAssinatura" [checkoutLiberado]="false"
                        [cartaoHabilitado]="!!destino?.opcao?.cartaoPaymentMethodId" [maxParcelas]="destino?.opcao?.maxParcelas ?? 1"
                        [rodape]="'O paciente segue no plano atual até a cobrança ser aprovada.'"
                        (voltar)="etapa = 'termo'" (semResposta)="onMaquininhaSemResposta()"></app-cobranca-sim>
    </ng-container>

    <!-- 5. Resultado -->
    <ng-container *ngIf="etapa === 'resultado'">
      <div class="flex gap-5 flex-wrap items-center">
        <div class="cartao-plano" [style.background-color]="corDestino.fundo" [style.color]="corDestino.texto"
             [style.box-shadow]="'0 14px 28px -16px ' + corDestino.sombra">
          <span class="cartao-marca">{{ nomePlano }}</span>
          <span class="cartao-nome">{{ nomeCurto(destino?.nome ?? '') }}</span>
        </div>
        <div class="flex-1" style="min-width: 230px">
          <p class="hero-titulo">Plano migrado para {{ nomeCurto(destino?.nome ?? '') }}</p>
        </div>
      </div>
      <p *ngIf="!antigaCancelada" class="aviso">O plano anterior ainda aparece ativo. Confira no admin do CartãoSiM.</p>
      <div *ngIf="faltando.length" class="erro" role="alert">
        Não ficaram ativos na assinatura nova:
        <ul class="lista-faltando"><li *ngFor="let d of faltando">{{ d.nome }}</li></ul>
        Cadastre pelo admin do CartãoSiM.
      </div>
    </ng-container>
  </ng-container>

  <p *ngIf="erro" class="erro" role="alert">{{ erro }}</p>
</div>
